import React, { useEffect, useState } from "react";
import { Card, Row, Col, Spinner, Button, Alert } from "react-bootstrap";

export default function CustomerGallery({ apiBase = "/api", customerId }) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [deletingId, setDeletingId] = useState(null);

  // Fetch images
  useEffect(() => {
    if (customerId) {
      fetchImages();
    } else {
      setImages([]);
    }
  }, [customerId]);

  const fetchImages = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${apiBase}/customers/${customerId}/images/`);
      const data = await res.json();
      if (!res.ok) throw new Error("Failed to load images");

      setImages(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this image?")) return;

    setDeletingId(id);
    try {
      const res = await fetch(`${apiBase}/images/${id}/delete/`, {
        method: "DELETE",
      });

      if (!res.ok) throw new Error("Delete failed");

      // Remove from UI
      setImages((prev) => prev.filter((img) => img.id !== id));
    } catch (err) {
      alert(err.message);
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <Card className="shadow-sm mt-3">
      <Card.Body>
        <h6 className="fw-semibold mb-3">Customer Image Gallery</h6>

        {error && <Alert variant="danger">{error}</Alert>}

        {loading ? (
          <Spinner animation="border" />
        ) : images.length === 0 ? (
          <div className="text-muted">No images found for this customer</div>
        ) : (
          <Row className="g-3">
            {images.map((img) => (
              <Col xs={6} md={4} lg={3} key={img.id}>
                <Card className="h-100">
                  <a href={img.url} target="_blank" rel="noreferrer">
                    <Card.Img
                      src={img.url}
                      style={{
                        height: 180,
                        objectFit: "cover",
                      }}
                    />
                  </a>

                  <Card.Body className="p-2 text-center">
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => handleDelete(img.id)}
                      disabled={deletingId === img.id}
                    >
                      {deletingId === img.id ? "Deleting..." : "Delete"}
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Card.Body>
    </Card>
  );
}
